import { createSnapshotValue as createMutable } from '../../lib/snapshot-value.ts'
/**
 * Spec §12.4: a supplier directory with approved legal and contact facts. Receipts and orders
 * name the supplier; a receipt also keeps a snapshot, so later edits never rewrite history.
 */
export type PaymentTerms = 'prepay' | 'deferred_7' | 'deferred_14' | 'deferred_30'

export const PAYMENT_TERMS_LABELS: Record<PaymentTerms, string> = {
  prepay: 'Передоплата 100%',
  deferred_7: 'Відстрочка 7 днів',
  deferred_14: 'Відстрочка 14 днів',
  deferred_30: 'Відстрочка 30 днів',
}

export interface SupplierContact {
  id: string
  version?: number
  fullName: string
  role: string
  phone: string | null
  email: string | null
  note: string | null
  primary: boolean
}

export interface SupplierGroup {
  id: string
  version?: number
  name: string
  archived: boolean
}

export interface ProtoSupplier {
  version?: number
  id: string
  name: string
  edrpou: string | null
  city: string
  address: string | null
  contactName: string | null
  phone: string | null
  email: string | null
  terms: PaymentTerms
  note: string | null
  groups: string[]
  contacts: SupplierContact[]
  archivedAt: string | null
  /** Names before a rename, so old receipts in the ledger still point here. */
  previousNames: string[]
}

export const SUPPLIERS: ProtoSupplier[] = createMutable([] as ProtoSupplier[])
export const SUPPLIER_GROUPS: SupplierGroup[] = createMutable([] as SupplierGroup[])
